import fix_icon1 from '../../../assets/images/fix_icon1.png';
import fix_icon2 from '../../../assets/images/fix_icon2.png';
import fix_icon3 from '../../../assets/images/fix_icon3.png';
import fix_icon4 from '../../../assets/images/fix_icon4.png';
import React, { useState, useEffect } from 'react'; // useEffect 추가

import fix_icon1_pc from '../../../assets/images/fix_icon1_pc.png';

export default function FixIcon() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(
        window.innerWidth <= 768 ||
          /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
      );
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleImageClick = (e) => {
    e.preventDefault();
    if (isMobile) {
      window.location.href = 'tel:1555-3811';
    } else {
      // PC에서는 새 창으로 이미지 열기
      window.open(fix_icon1_pc, '_blank', 'width=600,height=400');
    }
  };

  return (
    <>
      <div className="fixed_bottom col-flex flex-center gap-20">
        <a href="tel:1555-3811" onClick={handleImageClick}>
          <img
            src={fix_icon1}
            alt="상담 연결"
            style={{ cursor: 'pointer' }}
          />
        </a>
        <a href="/sub5_1">
          <img src={fix_icon2} alt="" />
        </a>
        <a href="/sub6_1">
          <img src={fix_icon3} alt="" />
        </a>
        <a target='_blank' href="https://pf.kakao.com/_xlxfxmNn/chat">
          <img src={fix_icon4} alt="" />
        </a>
      </div>
    </>
  );
}